import { type RefObject } from 'react';
import { PreferenceOptionsPage } from '../../components/PreferenceOptionPage/PreferenceOptionPage';
import styles from './FoodFormats.module.css';

interface Props {
  testid: string;
  scrollRef: RefObject<HTMLDivElement>;
}

export function FoodFormats(props: Props) {
  const title = 'What types of meals are you interested in?';

  return (
    <PreferenceOptionsPage
      testid={props.testid}
      heroText={title}
      ariaLabel="Select your meal types"
      preferenceOptionKey="preference_options.food_format"
      question="foodFormats"
      layoutVariant="three-column"
      toggleType="toggleFour"
      showRemark={true}
      textWrapperClass={styles['text-wrapper-padding-override']}
      scrollRef={props.scrollRef}
      trackingEventName="Quiz Food Formats"
    />
  );
}
